import type { HubPersona, DistributionListMember } from '../../models';
import { PersonType } from '../../models/hubPersona';
import { uniq, flatten } from '../..';

// Taken from owa-readwrite-recipient-well (modification: require a dot ending)
const emailAddressRegex: RegExp = /^[a-zA-Z0-9.!#$%&'’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/;

export function isValidEmailAddress(emailAddress: string): boolean {
    return emailAddressRegex.test(emailAddress);
}

export function hasEmail(persona: HubPersona | DistributionListMember): boolean {
    switch (persona.type) {
        case PersonType.Person:
        case PersonType.FavoritePerson:
        case PersonType.Generic:
            return !!persona.info.mainEmailAddress;
        case PersonType.PrivateDistributionListMember:
            return (
                !persona.isPdl &&
                persona.emailAddressWrapper &&
                !!persona.emailAddressWrapper.EmailAddress
            );
        case PersonType.PrivateDistributionList:
        case PersonType.FavoritePrivateDistributionList:
            return true;
        default:
            return false;
    }
}

export function getUniqueEmailAddressesFromPersona(persona: HubPersona): string[] {
    if (
        (persona.type === PersonType.Person || persona.type === PersonType.FavoritePerson) &&
        persona.info.allEmailAddresses &&
        persona.info.allEmailAddresses.length > 0
    ) {
        return uniq(
            persona.info.allEmailAddresses
                .filter(isValidEmailAddress)
                .map(email => email.toLowerCase())
        );
    }
    return [];
}

export function getUniqueEmailAddressesFromPersonas(personas: HubPersona[]): string[] {
    return uniq(flatten(personas.map(getUniqueEmailAddressesFromPersona)));
}

export function isAnyPersonaMultiEmailPersona(personas: HubPersona[]): boolean {
    return personas
        .map(getUniqueEmailAddressesFromPersona)
        .some(personaEmails => personaEmails.length > 1);
}
